module.exports = __webpack_public_path__ + "img/78.66f0532b.jpg";